// src/com/auto_plan_base_info/AutoPlanBaseInfo.js
import TopViewControl from '../../common/TopViewControl';
import ServiceTabs from '../menu_info/ServiceTabs';
import { menuRequestRepo } from '../../value/AppModel';
import AutoCppInfo from '../auto_cpp_info/AutoCppInfo'; // 출고 예정수량 등록
import AutoUsingCarInfo from '../auto_using_car_info/AutoUsingCarInfo'; // 가용차량 등록
import AutoComVehInfo from '../auto_com_veh_info/AutoComVehInfo'; // 운송사 차종 등록
import AutoDidaInfo from '../auto_dida_info/AutoDidaInfo'; // 점포휴무일 등록
import AutoPlanBindGroup from '../auto_plan_bind_group/AutoPlanBindGroup'; // 동적 점포 등록
import { AppMenuUrl } from '../../value/AppConst';

export default function AutoPlanBaseInfo({
    menu, parentMenu
}) {
    const onChangeTab = (v) => {
        const sib = parentMenu.children.find((child) => child.menuId === v);
        menuRequestRepo({menu:sib, parentMenu:parentMenu});
    };

    const viewServiceTags = <ServiceTabs menu={menu} parentMenu={parentMenu} onChangeTab={onChangeTab} />;

    /*
    AppMenuUrl.*
    ShippingPlan: 'TAB_AutoTab1', // 출고 예정수량 등록-AutoCppInfo
    AvailableTruck: 'TAB_AutoTab2', // 가용차량 등록-AutoUsingCarInfo
    TypeTonSet: 'TAB_AutoTab3', // 운송사 차종 등록-AutoComVehInfo
    StoreDida: 'TAB_AutoTab4', // 점포휴무일 등록-AutoDidaInfo
    StoresShareTruck: 'TAB_AutoTab5', // 동적 점포 등록
    */
    return(
        <TopViewControl>
            {
                (() => {
                    if(menu.menuUrl===AppMenuUrl.ShippingPlan) return <AutoCppInfo viewServiceTags={viewServiceTags} />;
                    if(menu.menuUrl===AppMenuUrl.AvailableTruck) return <AutoUsingCarInfo viewServiceTags={viewServiceTags} />;
                    if(menu.menuUrl===AppMenuUrl.TypeTonSet) return <AutoComVehInfo viewServiceTags={viewServiceTags} />;
                    if(menu.menuUrl===AppMenuUrl.StoreDida) return <AutoDidaInfo viewServiceTags={viewServiceTags} />;
                    if(menu.menuUrl===AppMenuUrl.StoresShareTruck) return <AutoPlanBindGroup viewServiceTags={viewServiceTags} />;
                    return null;
                })()
            }
        </TopViewControl>
    );
}